import _get from 'lodash/get';

import { getDateParts } from './getDateParts';
import { getSortablePeriodLabels } from './getSortablePeriodLabels';

const quarterEndDateMap = {
    '03-31': '1',
    '06-30': '2',
    '09-30': '3',
    '12-31': '4',
};

const convertDatePartsToLongName = (dateParts: DateParts): string =>
    `${dateParts.monthName} ${dateParts.day}, ${dateParts.year}`;

export const getPeriodLabels = (period: ProStatementPeriod): PeriodLabels => {
    const { unit } = period;
    const start = getDateParts(period.start_date);
    const end = getDateParts(period.end_date);
    let periodEnding = null;
    let dateRange = null;
    let short = null;

    if (unit === 'quarter' && period.end_date !== null && end !== null) {
        const { day, month, year } = end;
        const monthAndDay = `${month}-${day}`;
        const quarterNumber = _get(quarterEndDateMap, [monthAndDay]);

        if (quarterNumber !== undefined) {
            // If there is a matching quarter, include the quarter number and year in both the
            // dateRange and short labels.
            dateRange = `Quarter ${quarterNumber} ${year}`;
            short = `Q${quarterNumber} ${year}`;
        }

        // If possible, describe the quarter in the periodEnding label
        periodEnding = `Quarter ending ${convertDatePartsToLongName(end)}`;
    }

    if (unit !== 'quarter' && start !== null && end !== null) {
        const sortablePeriodLabels = getSortablePeriodLabels(period);

        /* eslint-disable prefer-destructuring */
        short = sortablePeriodLabels.short;
        dateRange = sortablePeriodLabels.long;
        /* eslint-enable prefer-destructuring */

        // If possible, describe the quarter in the periodEnding label
        periodEnding = `Period ending ${convertDatePartsToLongName(end)}`;
    }

    let shortestDateLabel = short;

    if (short === null) {
        shortestDateLabel = dateRange;

        if (dateRange === null) {
            shortestDateLabel = periodEnding;
        }
    }

    return {
        end,
        labels: { periodEnding, dateRange, short },
        shortestDateLabel,
        start,
        unit,
    };
};
